import { Component, OnInit, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { Input } from '@angular/core';
import { CdtStatus } from '../../app/cdt-status';
import { PublishStepper } from '../../context-discovery-services/models/publish-stepper.model';
import { StatusResolver } from '../../context-discovery-services/util';
import { isUndefined } from 'util';
import { SiteService } from '../../context-discovery-services/services/site.service';

@Component({
  selector: 'adminapp-publish',
  templateUrl: './publish.component.html',
  styleUrls: ['./publish.component.scss']
})
export class PublishComponent implements OnInit {

  dateTime: Array<String> = [
    'Abidjan',
    'Accra',
    'Adak',
    'Addis_Ababa',
    'Adelaide',
    'Aden',
    'Algiers',
    'Almaty',
    'Amman',
    'Amsterdam',
    'Anadyr',
    'Anchorage',
    'Andorra',
    'Antananarivo',
    'Antigua',
    'Apia',
    'Aqtau',
    'Aqtobe',
    'Araguaina',
    'Ashgabat',
    'Asmara',
    'Asuncion',
    'Athens',
    'Atikokan',
    'Auckland',
    'Azores',
    'Baghdad',
    'Bahia',
    'Bahia_Banderas',
    'Bahrain',
    'Baku',
    'Bangkok',
    'Barbados',
    'Beirut',
    'Belem',
    'Belgrade',
    'Belize',
    'Berlin',
    'Bermuda',
    'Beulah',
    'Bishkek',
    'Bissau',
    'Blanc-Sablon',
    'Boa_Vista',
    'Bogota',
    'Boise',
    'Brisbane',
    'Broken_Hill',
    'Brunei',
    'Brussels',
    'Bucharest',
    'Budapest',
    'Buenos_Aires',
    'Cairo',
    'Cambridge_Bay',
    'Campo_Grande',
    'Canary',
    'Cancun',
    'Cape_Verde',
    'Caracas',
    'Casablanca',
    'Casey',
    'Catamarca',
    'Cayenne',
    'Cayman',
    'Center',
    'CET',
    'Ceuta',
    'Chagos',
    'Chatham',
    'Chicago',
    'Chihuahua',
    'Chisinau',
    'Chita',
    'Choibalsan',
    'Christmas',
    'Chuuk',
    'Cocos',
    'Colombo',
    'Comoro',
    'Copenhagen',
    'Cordoba',
    'Costa_Rica',
    'Creston',
    'CST6CDT',
    'Cuiaba',
    'Curacao',
    'Currie',
    'Damascus',
    'Danmarkshavn',
    'Dar_es_Salaam',
    'Darwin',
    'Davis',
    'Dawson',
    'Dawson_Creek',
    'Denver',
    'Detroit',
    'Dhaka',
    'Dili',
    'Djibouti',
    'Dubai',
    'Dublin',
    'DumontDUrville',
    'Dushanbe',
    'Easter',
    'Edmonton',
    'EET',
    'Efate',
    'Eirunepe',
    'El_Aaiun',
    'El_Salvador',
    'Enderbury',
    'EST',
    'EST5EDT',
    'Eucla',
    'Fakaofo',
    'Faroe',
    'Fiji',
    'Fortaleza',
    'Funafuti',
    'Galapagos',
    'Gambier',
    'Gaza',
    'Gibraltar',
    'Glace_Bay',
    'Godthab',
    'Goose_Bay',
    'Grand_Turk',
    'Guadalcanal',
    'Guam',
    'Guatemala',
    'Guayaquil',
    'Guyana',
    'Halifax',
    'Havana',
    'Hebron',
    'Helsinki',
    'Hermosillo',
    'Ho_Chi_Minh',
    'Hobart',
    'Hong_Kong',
    'Honolulu',
    'Hovd',
    'HST',
    'Indianapolis',
    'Inuvik',
    'Iqaluit',
    'Irkutsk',
    'Istanbul',
    'Jakarta',
    'Jamaica',
    'Jayapura',
    'Jerusalem',
    'Johannesburg',
    'Jujuy',
    'Juneau',
    'Kabul',
    'Kaliningrad',
    'Kamchatka',
    'Kampala',
    'Karachi',
    'Kathmandu',
    'Kerguelen',
    'Khandyga',
    'Khartoum',
    'Kiev',
    'Kiritimati',
    'Knox',
    'Kolkata',
    'Kosrae',
    'Krasnoyarsk',
    'Kuala_Lumpur',
    'Kuching',
    'Kuwait',
    'Kwajalein',
    'La_Paz',
    'La_Rioja',
    'Lagos',
    'Lima',
    'Lindeman',
    'Lisbon',
    'London',
    'Lord_Howe',
    'Los_Angeles',
    'Louisville',
    'Luxembourg',
    'Macau',
    'Maceio',
    'Macquarie',
    'Madeira',
    'Madrid',
    'Magadan',
    'Mahe',
    'Majuro',
    'Makassar',
    'Maldives',
    'Malta',
    'Managua',
    'Manaus',
    'Manila',
    'Maputo',
    'Marengo',
    'Marquesas',
    'Martinique',
    'Matamoros',
    'Mauritius',
    'Mawson',
    'Mayotte',
    'Mazatlan',
    'Melbourne',
    'Mendoza',
    'Menominee',
    'Merida',
    'MET',
    'Metlakatla',
    'Mexico_City',
    'Midway',
    'Minsk',
    'Miquelon',
    'Mogadishu',
    'Monaco',
    'Moncton',
    'Monrovia',
    'Monterrey',
    'Montevideo',
    'Monticello',
    'Montreal',
    'Moscow',
    'MST',
    'MST7MDT',
    'Muscat',
    'Nairobi',
    'Nassau',
    'Nauru',
    'Ndjamena',
    'New_Salem',
    'New_York',
    'Nicosia',
    'Nipigon',
    'Niue',
    'Nome',
    'Norfolk',
    'Noronha',
    'Noumea',
    'Novokuznetsk',
    'Novosibirsk',
    'Ojinaga',
    'Omsk',
    'Oral',
    'Oslo',
    'Pago_Pago',
    'Palau',
    'Palmer',
    'Panama',
    'Pangnirtung',
    'Paramaribo',
    'Paris',
    'Perth',
    'Petersburg',
    'Phnom_Penh',
    'Phoenix',
    'Pitcairn',
    'Pohnpei',
    'Pontianak',
    'Port_Moresby',
    'Port_of_Spain',
    'Port-au-Prince',
    'Porto_Velho',
    'Prague',
    'PST8PDT',
    'Puerto_Rico',
    'Pyongyang',
    'Qatar',
    'Qyzylorda',
    'Rainy_River',
    'Rangoon',
    'Rankin_Inlet',
    'Rarotonga',
    'Recife',
    'Regina',
    'Resolute',
    'Reunion',
    'Reykjavik',
    'Riga',
    'Rio_Branco',
    'Rio_Gallegos',
    'Riyadh',
    'Rome',
    'Rothera',
    'Saipan',
    'Sakhalin',
    'Salta',
    'Samara',
    'Samarkand',
    'San_Juan',
    'San_Luis',
    'Santa_Isabel',
    'Santarem',
    'Santiago',
    'Santo_Domingo',
    'Sao_Paulo',
    'Scoresbysund',
    'Seoul',
    'Shanghai',
    'Simferopol',
    'Singapore',
    'Sitka',
    'Sofia',
    'South_Georgia',
    'Srednekolymsk',
    'St_Johns',
    'Stanley',
    'Stockholm',
    'Swift_Current',
    'Sydney',
    'Syowa',
    'Tahiti',
    'Taipei',
    'Tallinn',
    'Tarawa',
    'Tashkent',
    'Tbilisi',
    'Tegucigalpa',
    'Tehran',
    'Tell_City',
    'Thimphu',
    'Thule',
    'Thunder_Bay',
    'Tijuana',
    'Tirane',
    'Tokyo',
    'Tongatapu',
    'Toronto',
    'Tripoli',
    'Troll',
    'Tucuman',
    'Tunis',
    'Ulaanbaatar',
    'Urumqi',
    'Ushuaia',
    'Ust-Nera',
    'Uzhgorod',
    'Vancouver',
    'Vevay',
    'Vienna',
    'Vientiane',
    'Vilnius',
    'Vincennes',
    'Vladivostok',
    'Volgograd',
    'Vostok',
    'Wake',
    'Wallis',
    'Warsaw',
    'WET',
    'Whitehorse',
    'Winamac',
    'Windhoek',
    'Winnipeg',
    'Yakutat',
    'Yakutsk',
    'Yekaterinburg',
    'Yellowknife',
    'Yerevan',
    'Zaporozhye',
    'Zurich'];

  @ViewChild('publishModal') publishModal: any;
  @ViewChild('continueButton') continueButton: any;
  @ViewChild('publishButton') publishButton: any;

  @ViewChild('statusIndicationHolder') statusIndicationHolder: any;
  @ViewChild('publishStatusDialog') publishStatusDialog: any;

  private _modelId: any;
  selectedTimeZone: String;
  timeZoneSelectorDomRepeat: any;
  timeZoneSelector: any;
  _isPublishInProgress: boolean;
  _isAutomaticAnalyticsSetupFeatureEnabled: boolean;
  _completeOnboardingStatus: PublishStepper[];
  statusAggregator: CdtStatus = undefined;
  statusResolver: StatusResolver;
  isFetchingTimezoneInfo: boolean;

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId !== idOfModel) {
      this._modelId = idOfModel;
    }
  }

  @Input()
  set isPublishInProgress(isPublishInProgress: boolean) {
    if (this._isPublishInProgress !== isPublishInProgress) {
      this._isPublishInProgress = isPublishInProgress;
    }
  }

  @Input()
  set isAutomaticAnalyticsSetupFeatureEnabled(automaticAnalyticsSetupFeatureEnabled: boolean) {
    if (this._isAutomaticAnalyticsSetupFeatureEnabled !== automaticAnalyticsSetupFeatureEnabled) {
      this._isAutomaticAnalyticsSetupFeatureEnabled = automaticAnalyticsSetupFeatureEnabled;
    }
  }

  @Input()
  set completeOnboardingStatus(completeOnboardingStatus: any) {
    if (JSON.stringify(this._completeOnboardingStatus) !== JSON.stringify(completeOnboardingStatus)) {
      this._completeOnboardingStatus = completeOnboardingStatus;
      this.statusAggregator = this.statusResolver.getStatusOfPublishWithAutomaticAnalyticsSetup(this._completeOnboardingStatus,
        this._isAutomaticAnalyticsSetupFeatureEnabled);
    }
  }

  @Output()
  publishSiteEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elRef: ElementRef, private siteService: SiteService) {
    this.statusResolver = new StatusResolver();
  }

  ngOnInit() {
    this.publishButton.nativeElement.addEventListener('click', this.openDialog.bind(this));
    this.continueButton.nativeElement.addEventListener('click', this.onContinueClicked.bind(this));
    this.timeZoneSelectorDomRepeat = this.elRef.nativeElement.querySelector('coretex-select dom-repeat');
    this.timeZoneSelectorDomRepeat.items = this.dateTime;
    this.timeZoneSelector = this.elRef.nativeElement.querySelector('coretex-select');
    this.timeZoneSelector.addEventListener('change', this.setSelectedTimeZone.bind(this));

    this.statusIndicationHolder.nativeElement.addEventListener('mouseover', this.openStatusDialog.bind(this));
    this.statusIndicationHolder.nativeElement.addEventListener('mouseout', this.closeStatusDialog.bind(this));
  }

  setSelectedTimeZone(event: any) {
    if (!isUndefined(event.detail.index)) {
      this.selectedTimeZone = event.detail.value;
    } else {
      this.selectedTimeZone = null;
    }
  }

  openDialog() {
    if (this._isAutomaticAnalyticsSetupFeatureEnabled) {
      this.isFetchingTimezoneInfo = true;
      this.siteService.getTimezoneConfiguredToPublishWithAutoSetupAnalytics(this._modelId)
        .subscribe(this.getTimezoneInfoSuccessCallback.bind(this), this.getTimezoneInfoFailureCallback.bind(this));
    } else {
      this.publishSiteEventEmitter.emit({});
    }
  }

  getTimezoneInfoSuccessCallback(timezone: string): any {
    this.isFetchingTimezoneInfo = false;
    if (timezone) {
      this.selectedTimeZone = timezone;

      this.publishSiteEventEmitter.emit({
        timezone: this.selectedTimeZone
      });
    } else {
      this.selectedTimeZone = null;
      this.publishModal.nativeElement.open();
    }
  }

  getTimezoneInfoFailureCallback(): any {
    this.isFetchingTimezoneInfo = false;
    this.selectedTimeZone = null;
    this.publishSiteEventEmitter.emit({ timezone: this.selectedTimeZone});
  }

  openStatusDialog(element) {
    if (this.publishStatusDialog) {
      this.publishStatusDialog.positionTarget = element;
      this.publishStatusDialog.open();
    }
  }

  closeStatusDialog() {
    this.publishStatusDialog.close();
  }

  closeDialog() {
    this.publishModal.nativeElement.close();
  }

  onContinueClicked() {
    if (this.selectedTimeZone) {
      if (this.timeZoneSelector.$.inputSelector.value !== this.selectedTimeZone) {
        this.selectedTimeZone = null;
      } else {
        this.publishSiteEventEmitter.emit({
          timezone: this.selectedTimeZone
        });
        this.closeDialog();
      }
    }
  }

  isStatusAggregatorForPublishFailed(): boolean {
    return (this.statusAggregator === CdtStatus.PUBLISH_FAILED);
  }

  isStatusAggregatorForPublishSucceeded(): boolean {
    return (this.statusAggregator === CdtStatus.SUCCEEDED);
  }

  isStatusAggregatorForPublishInProgress(): boolean {
    return (this.statusAggregator === CdtStatus.PUBLISH_IN_PROGRESS);
  }
}
